import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { GqlOperation, IGqlOperationLogger, RequestFn } from "./GqlOperation";
import { getOperationName } from "./utils";

export class GqlOperationFactory {
  private _logger: IGqlOperationLogger;
  private _request: RequestFn;

  constructor(args: { logger?: IGqlOperationLogger; request: RequestFn }) {
    this._logger = args.logger ?? console;
    this._request = args.request;
  }

  createFromGql<V extends Record<string, unknown>, D extends Record<string, unknown>>(options: {
    canWorkWithShareLinks: boolean;
    document: TypedDocumentNode<D, V>;
  }) {
    const operationName = getOperationName(options.document);
    return new GqlOperation({
      canWorkWithShareLinks: options.canWorkWithShareLinks,
      document: options.document,
      logger: this._logger,
      operationName,
      requestFn: this._request,
    });
  }
}
